import React from 'react';
// Components
import GeneralMainSection from '../general/GeneralMainSection';
// Images
import ConstructionImage from '../../assets/images/main/ascari-building-contractors-landscaping-and-carpentry-construction-roof.jpg';
import ConstructionImage2 from '../../assets/images/main/ascari-building-contractors-landscaping-and-carpentry-construction-rooms.jpg';
import ConstructionImage3 from '../../assets/images/main/ascari-building-contractors-landscaping-and-carpentry-construction-roof-construction-path.jpg';
import GeneralFooter from '../general/GeneralFooter';

function BuildingPageMainContainer() {
  const buildingPageData = {
    headerSentence: 'Expert Construction & Renovation Services',
    description:
      "At Ascari Building Contractors, we specialize in expert home and commercial renovations, delivering high-quality craftsmanship that enhances functionality, style, and value. Whether it's a full property transformation or a smaller upgrade, our experienced team ensures a seamless construction process from start to finish.",
    services: [
      {
        title: 'Structural Modifications',
        description:
          'Altering layouts for open-plan living or new configurations.',
      },
      {
        title: 'Flooring & Skirting',
        description:
          'Installation of timber, laminate, or engineered wood flooring with a polished finish.',
      },
      {
        title: 'Custom Storage Solutions',
        description:
          'Bespoke cabinetry and shelving to maximize space and reduce clutter.',
      },
      {
        title: 'Ceilings & Partitioning',
        description:
          'Timber framing and plasterboarding for improved functionality and aesthetic appeal.',
      },
      {
        title: 'Rotted Floor Joist Repairs',
        description:
          'Professional dry rot solutions to restore flooring integrity and ensure durability.',
      },
      {
        title: 'Loft Conversions',
        description:
          'From full-width dormers to small conversions, we create additional living space with bedrooms, en-suites, or optimized storage areas.',
      },
    ],
    commitment:
      'Our dedicated team of carpenters, builders, electricians, and plumbers work closely with you to bring your vision to life while ensuring a smooth and efficient construction process. We pride ourselves on delivering exceptional quality with minimal disruption.',
    mainImage: ConstructionImage3,
    secondImage: ConstructionImage,
    mainImageAlt: 'Construction site in progress',
    imageTwo: ConstructionImage2,
    imageThree: ConstructionImage,
  };

  return (
    <main
      role='main'
      className='grid pt-8 sm:pt-10 md:pt-12 gap-12 lg:gap-24 w-full h-full'
    >
      <GeneralMainSection {...buildingPageData} />

      <GeneralFooter title={`Construction`} />

    </main>
  );
}

export default BuildingPageMainContainer;
